import React, {useState} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {withRouter} from 'react-router-dom';
import {TopNavigation} from '@forecast-it/design-system';
import AgentTriggerButton from '../../../components/PrimaryNavigation/AgentTriggerButton';
import CreateButton, {CreateButtonQuery, DropDownButton as CreateDropDownButton} from '../header/CreateButton';
import ProfileButton from '../header/ProfileButton';
import HelpButton from '../header/HelpButton';
import GlobalSearchV2 from '../header/global-search/GlobalSearchButton';
import Util from '../../shared/util/util';
import Timer, {TimerLoader, TimerQuery} from '../header/Timer';
import {withSocketHandling} from '../../../socket/withSocketHandling';
import {ForecastQueryRenderer} from '../../../ForecastQueryRenderer';
import {getProjectIdFromPath} from '../../shared/util/UrlContextUtil';
import RecentButton, {DropDownButton as RecentDropdownButton, RecentButtonQuery} from '../header/RecentButton';
import KeyboardShortcuts from '../header/KeyboardShortcuts';
import {useIntl} from 'react-intl';
import {hasPermission, isClientUser} from '../../shared/util/PermissionsUtil';
import {PERMISSION_TYPE} from '../../../Permissions';
import {hasFeatureFlag} from '../../shared/util/FeatureUtil';
import NotificationMenu from '../header/NotificationMenu';
import {HIDDEN_FEATURES} from '../../../constants';
import {isFeatureHidden} from '../../shared/util/CompanySetupUtil';

const PrimaryNavigationRight = props => {
	const {viewer} = props;
	const {actualPersonId} = props;
	const [timerHidden, setTimerHidden] = useState(
		localStorage.getItem('header-hide-timer') ? JSON.parse(localStorage.getItem('header-hide-timer')) : false
	);
	const currentPath = window.location.pathname + window.location.hash;
	const {formatMessage} = useIntl();

	return (
		<TopNavigation.Right>
			<KeyboardShortcuts key={'KeyboardShortcuts'} actualPersonId={actualPersonId} />

			{!timerHidden && !isClientUser() && !isFeatureHidden(HIDDEN_FEATURES.TIME_REGISTRATIONS) ? (
				<ForecastQueryRenderer
					key="query-render-timer_component"
					query={TimerQuery}
					customLoader={() => TimerLoader}
					render={relayProps => <Timer {...relayProps} personId={actualPersonId} />}
				/>
			) : null}

			<div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
				<ForecastQueryRenderer
					key="query-render-create_button"
					query={CreateButtonQuery}
					variables={{
						projectId: getProjectIdFromPath(currentPath),
						companyId: viewer.company.id,
					}}
					customLoader={() => CreateDropDownButton(formatMessage)}
					render={relayProps => <CreateButton {...relayProps} />}
				/>

				{hasFeatureFlag('forecast_agent_chat') && hasPermission(PERMISSION_TYPE.MANAGE_ACCOUNT_SETTINGS) && (
					<AgentTriggerButton />
				)}
			</div>

			<TopNavigation.Controls>
				<GlobalSearchV2 companyId={viewer.company.id} personId={viewer.backendId} />

				<ForecastQueryRenderer
					key="query-render-top_navigation-favorites"
					query={RecentButtonQuery}
					variables={{}}
					redirectIfNotLoggedIn={true}
					customLoader={() => RecentDropdownButton}
					render={(relayProps, retry) => <RecentButton retry={retry} {...relayProps} />}
				/>
				<NotificationMenu viewer={viewer} />
				<HelpButton />
				<ProfileButton
					viewer={viewer}
					timerHidden={timerHidden}
					onToggleTimer={() => {
						Util.localStorageSetItem('header-hide-timer', !timerHidden);
						setTimerHidden(!timerHidden);
					}}
				/>
			</TopNavigation.Controls>
		</TopNavigation.Right>
	);
};

const PrimaryNavigationRightQuery = graphql`
	query PrimaryNavigationRight_Query {
		viewer {
			actualPersonId
			component(name: "top_navigation_right")
			...PrimaryNavigationRight_viewer
		}
	}
`;

export {PrimaryNavigationRightQuery};

export default withRouter(
	withSocketHandling(
		createFragmentContainer(PrimaryNavigationRight, {
			viewer: graphql`
				fragment PrimaryNavigationRight_viewer on Viewer {
					id
					sisenseUserId
					backendId
					unseenNotifications
					projectOwner
					company {
						id
						name
						useTimeApproval
						useTimeOffApproval
						unit4Enabled
						isUsingProjectAllocation
						tier
					}
					...NotificationMenu_viewer
				}
			`,
		})
	)
);
